import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "section-mainnet-environment" }
const _hoisted_2 = { class: "flex justify-start p-3" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-main-net relative top-1\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span></span>", 1)
const _hoisted_4 = { class: "px-3" }
const _hoisted_5 = { class: "text-gray-300 font-bold mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-blue-primary font-bold pt-1"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-release-test-net relative top-0.5\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span><span class=\"path5\"></span><span class=\"path6\"></span><span class=\"path7\"></span><span class=\"path8\"></span><span class=\"path9\"></span></span>", 1)
const _hoisted_8 = {
  key: 2,
  class: "text-gray-text pt-1"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Connect")
const _hoisted_10 = {
  key: 3,
  class: "text-gray-text pt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_gamesConfirmCreateNamespaceModal = _resolveComponent("gamesConfirmCreateNamespaceModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.mainnetLabel) + " Environment", 1),
        (_ctx.status === 4)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Game is currently active in " + _toDisplayString(_ctx.mainnetLabel), 1))
          : _createCommentVNode("", true),
        (_ctx.status === 3 && _ctx.userData.mainnetWalletAddress != '')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn-primary md:w-full mt-1",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.publishGameMainnet && _ctx.publishGameMainnet(...args)))
            }, [
              _hoisted_7,
              _createTextVNode("  Release in " + _toDisplayString(_ctx.mainnetLabel), 1)
            ]))
          : (_ctx.status === 3 && _ctx.userData.mainnetWalletAddress == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: { name: 'viewHomeSettings' },
                  class: "text-blue-primary hover:underline duration-200 transition-all"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createTextVNode(" to " + _toDisplayString(_ctx.mainnetLabel) + " wallet to release this game on " + _toDisplayString(_ctx.mainnetLabel), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, "You have no updates yet.")),
        _createVNode(_component_gamesConfirmCreateNamespaceModal, {
          network: "mainnet",
          onCloseModel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isQRModalShow = false)),
          onConfirmedButtonPressed: _ctx.saveGameMainnet,
          isQRModalShow: _ctx.isQRModalShow,
          qr: _ctx.qr,
          showUploadingLoader: _ctx.showUploadingLoader,
          isDisabledModalConfirmSubmitButton: _ctx.isDisabledModalConfirmSubmitButton
        }, null, 8, ["onConfirmedButtonPressed", "isQRModalShow", "qr", "showUploadingLoader", "isDisabledModalConfirmSubmitButton"])
      ])
    ])
  ]))
}